import { InputField } from "@/components/common/InputField";
import { INPUT_STYLE, focusRingOn, focusRingOff } from "@/lib/form-styles";

interface TextInputFieldProps {
	label: string;
	value: string;
	onChange: (value: string) => void;
	error?: string;
	placeholder?: string;
	type?: "text" | "email" | "password";
	autoComplete?: string;
}

export function TextInputField({
	label,
	value,
	onChange,
	error,
	placeholder,
	type = "text",
	autoComplete,
}: TextInputFieldProps) {
	return (
		<InputField label={label} error={error}>
			<input
				type={type}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				placeholder={placeholder}
				autoComplete={autoComplete}
				style={INPUT_STYLE}
				onFocus={(e) => focusRingOn(e.currentTarget)}
				onBlur={(e) => focusRingOff(e.currentTarget)}
			/>
		</InputField>
	);
}
